import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { MaterialElevationDirective } from './mat-directives/material-elevetion.directive';
import { CalendarComponent } from './calendar/calendar.component';
import { ProfileComponent } from './profile/profile.component';
import { CardComponent } from './card/card.component';
import { ButtonComponent } from './button/button.component';
import { TableComponent } from './table/table.component';
import { DialogComponent } from './dialog/dialog.component';
import { PrismModule } from '@ngx-prism/core';
import { IconComponent } from './icon/icon.component';
import { SnackbarComponent } from './snackbar/snackbar';
import { BarChartComponent } from './charts/barcharts/barchart.component';

import { ChartsModule } from 'ng2-charts';
import { LineChartComponent } from './charts/linecharts/linechart.component';
import { PieChartComponent } from './charts/piecharts/piechart.component';
import { formPageDeclaration } from './dynamic-form-builder/dynamicFormDeclaration';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchSelectDeclarations } from './search-select/search-select';
import { StarRatingComponent } from './star-rating/star-ratting.component';
import { D3ChartComponent } from './charts/d3charts/d3chart.component';
import { D3ChartComponent2 } from './charts/d3charts2/d3chart.component';
import { BackButtonDirective } from './back-button/back-button.directives';
import { NoDataComponents } from './no-data-found/no-data-found.component';
import { TitleBarComponent } from './title-bar/title-bar.component';
import { SearchComponent } from './search/search.component';
import { FloatingButton } from './floating-button/floating-button.directive';
import { TopMenuHeaderComponent } from './top-menu-header/top-menu-header.component';
import { PaginationComponent } from './pagination/pagination';
import { FilterComponents } from './filters/filter.page.declaration';

import { AddMemberdirective } from './add-member/add-member';


// import { RosteringPageDeclaration } from './roastering/roastering.declaration';
import { ApexRadialBarChart } from './charts/apex/radial-bar-chart';
import { ApexBarChartBasic } from './charts/apex/bar-chart-basic';

import { MaterialChips } from './chips/material-chips';
import { DatePicker } from './date-picker/date-picker';
//chartjs

import { BarChart} from './charts/chart-js/barchart/barchart';
import { PiechartComponent} from './charts/chart-js/piechart/piechart.component';

// arm chart

import { ArmPiechartComponent} from './charts/arm-chart/arm-pie-chart';

// breadcrumb
import { BreadcrumbComponent} from './breadcrumbs/breadcrumb.component';
import { HighchartBarchartComponent } from './charts/highcharts/highchart-barchart/highchart-barchart.component';

//Geofence
import { GeofenceLocationComponent } from './geofence-location/geofence-location.component';


export const DirectiveDeclaration = [
  MaterialElevationDirective,HeaderComponent,FooterComponent,SidebarComponent, CalendarComponent,
  ProfileComponent, CardComponent,  ButtonComponent,  TableComponent,  DialogComponent,
  IconComponent,  SnackbarComponent,  BarChartComponent,LineChartComponent,  PieChartComponent,
  ApexRadialBarChart,  ApexBarChartBasic,formPageDeclaration,  StarRatingComponent,  D3ChartComponent,
  D3ChartComponent2, BackButtonDirective,  NoDataComponents, TitleBarComponent,  SearchComponent,FloatingButton,
  GeofenceLocationComponent,
  // RosteringPageDeclaration
  TopMenuHeaderComponent,  PaginationComponent, FilterComponents, SearchSelectDeclarations,MaterialChips,
  DatePicker,  AddMemberdirective , BarChart, PiechartComponent,
  ArmPiechartComponent, BreadcrumbComponent,


  //Highchart
  HighchartBarchartComponent
]

